import { memo } from "react";
import { describeArc } from '../utils/polar';

const R = 20;

type Props = {
  cx: number;
  cy: number;
  state: boolean;
  icon: React.ReactNode;
};

export const StatusIndicatorPill = memo(function StatusIndicatorPill({ cx, cy, state, icon }: Props) {
  const underlineColor = state ? '#22c55e' : '#ef4444';

  return (
    <g>
      {/* Transparent background + thin ring */}
      <circle cx={cx} cy={cy} r={R} fill="none" stroke="#2e3545" strokeWidth="1.5" />
      {/* Underline arc — bottom ~50° centered at SVG 90° (bottom) */}
      <path
        d={describeArc(cx, cy, R, 65, 115)}
        fill="none"
        stroke={underlineColor}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Icon via foreignObject */}
      <foreignObject x={cx - 10} y={cy - 11} width="20" height="20">
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
          }}
        >
          {icon}
        </div>
      </foreignObject>
    </g>
  );
});
